import { useAuth } from '../../apis/auth/AuthProvider'
import LoginTemplate from '../../concepts/giantsys-tracking/components/templates/LoginTemplate';

import React, { useState, useEffect } from 'react';
import './index.scss';

import BackgroundImage from '../../images/Background.jpg';
import Logo from '../../images/GiantLogo.jpg';

import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [inputUsername, setInputUsername] = useState("");
  const [inputPassword, setInputPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorData, setErrorData] = useState(
    {
      status: null,
      messages: null
    }
  );

  const auth = useAuth();
  const navigate = useNavigate();
  
  const handleVerifyLogin = () => {}
  const handleErrorVerifyLogin = () => {  }

  useEffect(() => {
    auth.verifyLogin(handleVerifyLogin, handleErrorVerifyLogin, false, false).then((isLoggedIn)=> {
      if(isLoggedIn){
        navigate('/home');
      }
    });
  });

  const loginErrorHandle = (errorResponse) =>{
    let data = errorResponse.response.data;
    var errorData = {
      status: errorResponse.response.status,
      messages: data.messages
    }
    setErrorData(errorData);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    let language = navigator.language;

    let data = {
      username: inputUsername,
      password: inputPassword,
      systemId: 1,
      language: language
    }

    auth.loginAction(data, loginErrorHandle);
    setErrorData({
      status: null,
      message: null
    });

    setLoading(false);
  };

  return (
    <LoginTemplate
      backgroundImage={BackgroundImage}
      logo={Logo}
      loading={loading}
      errorData={errorData}
      setErrorData={setErrorData}
      handleSubmit={handleSubmit}
      onUserChange={(e) => setInputUsername(e.target.value)}
      onPasswordChange={(e) => setInputPassword(e.target.value)}
    />
  );
};

export default Login;
